import React from "react";

import { AncillaryAssetsList } from "./AncillaryAssetsList";
import { SingleAncillaryProvider } from "./context/SingleAncillaryProvider";

export const AncillaryAssetsListDashboard: React.FC = () => {
    return (
        <SingleAncillaryProvider>
            <AncillaryAssetsList />
        </SingleAncillaryProvider>
    );
};
